import { ListLivrables } from "./ListLivrables/ListLivrables"
import { DetailActif } from "./DetailActif/DetailActif"
export default function TabLivrable()

{ 
    return (
<>
<DetailActif/>

<ListLivrables />
</>

)
}